const VALIDATION_TRANSLATIONS = {
  english:    { required: 'Required',       onlyNumbers: 'Only numbers are allowed',        maxLength: 'Maximum {n} characters allowed' },
  irish:      { required: 'Required',       onlyNumbers: 'Only numbers are allowed',        maxLength: 'Maximum {n} characters allowed' },
  portuguese: { required: 'Obrigatório',    onlyNumbers: 'Apenas números são permitidos',   maxLength: 'Máximo de {n} caracteres permitidos' },
  albanian:   { required: 'E detyrueshme',  onlyNumbers: 'Vetëm numrat lejohen',            maxLength: 'Maksimumi i {n} karaktereve të lejuara' },
  german:     { required: 'Erforderlich',   onlyNumbers: 'Nur Zahlen sind erlaubt',         maxLength: 'Maximal {n} Zeichen erlaubt' },
  spanish:    { required: 'Obligatorio',    onlyNumbers: 'Solo se permiten números',        maxLength: 'Máximo de {n} caracteres permitidos' },
  french:     { required: 'Obligatoire',    onlyNumbers: 'Seuls les chiffres sont autorisés', maxLength: 'Maximum {n} caractères autorisés' },
  italian:    { required: 'Obbligatorio',   onlyNumbers: 'Sono ammessi solo numeri',        maxLength: 'Massimo {n} caratteri consentiti' },
  dutch:      { required: 'Verplicht',      onlyNumbers: 'Alleen cijfers zijn toegestaan',  maxLength: 'Maximaal {n} tekens toegestaan' },
  greek:      { required: 'Απαιτείται',     onlyNumbers: 'Επιτρέπονται μόνο αριθμοί',      maxLength: 'Επιτρέπονται έως {n} χαρακτήρες' },
  turkish:    { required: 'Zorunlu',        onlyNumbers: 'Sadece rakamlara izin verilir',   maxLength: 'Maksimum {n} karakter izni' },
  romanian:   { required: 'Obligatoriu',    onlyNumbers: 'Sunt permise doar cifre',         maxLength: 'Maximum {n} caractere permise' },
  czech:      { required: 'Povinné',        onlyNumbers: 'Jsou povolena pouze čísla',       maxLength: 'Maximálně {n} znaků povoleno' },
  hungarian:  { required: 'Kötelező',       onlyNumbers: 'Csak számok engedélyezettek',     maxLength: 'Maximum {n} karakter megengedett' },
};

export function getRequiredText(languageName) {
  const lang = (languageName || 'english').toLowerCase();
  return (VALIDATION_TRANSLATIONS[lang] || VALIDATION_TRANSLATIONS.english).required;
}

export function getOnlyNumbersText(languageName) {
  const lang = (languageName || 'english').toLowerCase();
  return (VALIDATION_TRANSLATIONS[lang] || VALIDATION_TRANSLATIONS.english).onlyNumbers;
}

export function getMaxLengthText(languageName, n) {
  const lang = (languageName || 'english').toLowerCase();
  const template = (VALIDATION_TRANSLATIONS[lang] || VALIDATION_TRANSLATIONS.english).maxLength;
  return template.replace('{n}', n);
}

export default VALIDATION_TRANSLATIONS;
